module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', {
    staticClass: "f2 lh-copy pt3"
  }, [_vm._v("File New Claim")]), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Inquiry Regarding Banned Account"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": "mailto:billing@getakko.com?Subject=Re-enable my plan"
    }
  }, [_vm._v("please contact our billing team.")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (this.currentTab === 0) ? _c('div', {
    staticClass: "tab",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "f8 mb3 lh-copy"
  }, [_vm._v("\n        If an item was affected which has not been added to your account, please\n        "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_vm._v("add it here")]), _vm._v("\n        then file your claim.\n      ")], 1), _vm._v(" "), (_vm.registered_devices.length > 0) ? _c('div', {
    staticClass: "flex flex-wrap pb3"
  }, _vm._l((_vm.registered_devices), function(device, index) {
    return _c('div', {
      key: index,
      staticClass: "mr4 mb3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.devices),
        expression: "devices"
      }],
      staticClass: "dn",
      attrs: {
        "type": "checkbox",
        "id": device.id
      },
      domProps: {
        "value": device.id,
        "checked": Array.isArray(_vm.devices) ? _vm._i(_vm.devices, device.id) > -1 : (_vm.devices)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.devices,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = device.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.devices = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.devices = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.devices = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "db pv2 ph3 f8 tc b ba br-pill b-theme bg-white color-theme pointer",
      attrs: {
        "for": device.id
      }
    }, [_vm._v(_vm._s(device.nickname))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.registered_devices.length == 0) ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("You haven't added any items to your account.")]), _vm._v(" "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_c('u', [_vm._v("Add your items here.")])])], 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (this.currentTab === 1) ? _c('div', {
    staticClass: "tab",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "mt4"
  }, [_c('div', {
    staticClass: "mv4"
  }, [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loss_type),
      expression: "loss_type"
    }],
    staticClass: "b--black-20 pa2 mb3 db w-100 br1",
    attrs: {
      "id": "loss_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.loss_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a type of loss")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_c('label', {
    staticClass: "db fw8 f3 mb2",
    attrs: {
      "for": "known_damage"
    }
  }, [_vm._v("Previous known damage:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.known_damage),
      expression: "known_damage"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "known_damage",
      "maxlength": "1000",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.known_damage)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.known_damage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fr f8 mt1 silver"
  }, [_vm._v(_vm._s(_vm.dmg_count) + "/1000 characters")])])])])]) : _vm._e(), _vm._v(" "), (this.currentTab === 2) ? _c('div', {
    staticClass: "tab",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "mv4"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loss_date),
      expression: "loss_date"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "loss_date",
      "type": "date",
      "max": _vm.today_string
    },
    domProps: {
      "value": (_vm.loss_date)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loss_date = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_vm._m(6), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "description",
      "maxlength": "1000",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }, [_vm._v(_vm._s(this.currentClaim.description) + "\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "fr f8 mt1 silver"
  }, [_vm._v(_vm._s(_vm.desc_count) + "/1000 characters")]), _vm._v(" "), (_vm.descriptionValidationMessages.error) ? _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "descriptionvalidationmessage"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.descriptionValidationMessages.error) + "\n        ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (this.currentTab === 3) ? _c('div', {
    staticClass: "tab",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "f5 mb3 inter text-with-icon"
  }, [_c('info-icon'), _vm._v(" Provide clear images of damage, evidence, and/or the copy of your police report.\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "uploadWrapper"
  }, [(!_vm.loading) ? _c('form', {
    staticClass: "imageUploadForm",
    attrs: {
      "id": "imageUploadForm"
    }
  }, [_c('image-icon'), _vm._v(" "), _c('span', {
    staticClass: "helpText"
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('input', {
    staticClass: "uploadButton",
    attrs: {
      "type": "file",
      "id": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.previewImage
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.getClaimImages.length > 0) ? _c('div', {
    staticClass: "images-list"
  }, _vm._l((this.getClaimImages), function(image) {
    return _c('div', {
      key: image.filename,
      staticClass: "images-list-item"
    }, [_c('div', {
      staticClass: "images-list-item-detail-icon"
    }, [_c('image-icon')], 1), _vm._v(" "), _c('div', {
      staticClass: "images-list-item-detail-name"
    }, [_vm._v("\n                  " + _vm._s(image.filename) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "images-list-item-detail-remove"
    }, [_c('span', {
      staticClass: "images-list-item-remove-btn",
      on: {
        "click": function($event) {
          return _vm.deleteImage(image.id)
        }
      }
    })])])
  }), 0) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (this.currentTab === 4) ? _c('div', {
    staticClass: "tab",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "grid-half"
  }, [_c('div', {}, [_c('div', {}, [_c('label', {
    staticClass: "f3 b db mb2",
    attrs: {
      "for": "paypalemail"
    }
  }, [_vm._v("Your PayPal Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paypalemail),
      expression: "paypalemail"
    }],
    staticClass: "input-email ba b--black-20 pa2 mb2 db w-100 br1 w-50-ns",
    attrs: {
      "id": "paypalemail",
      "name": "paypalemail",
      "type": "email",
      "disabled": _vm.paypalEmailChkbx,
      "autocomplete": "paypalemail"
    },
    domProps: {
      "value": (_vm.paypalemail)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paypalemail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.emailValidationMessages.error) ? _c('div', {
    staticClass: "red f7 mt2",
    attrs: {
      "id": "emailvalidationmessage"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.emailValidationMessages.error) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paypalEmailChkbx),
      expression: "paypalEmailChkbx"
    }],
    staticClass: "normal",
    attrs: {
      "id": "paypalEmailChkbx",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.paypalEmailChkbx) ? _vm._i(_vm.paypalEmailChkbx, null) > -1 : (_vm.paypalEmailChkbx)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.paypalEmailChkbx,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.paypalEmailChkbx = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.paypalEmailChkbx = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.paypalEmailChkbx = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "dib fw5 f6 mb2 inter",
    attrs: {
      "for": "paypalEmailChkbx"
    }
  }, [_vm._v("I don't have PayPal")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt4",
    class: [!_vm.userHasAccess ? 'pb4' : '']
  }, [_c('h3', {
    staticClass: "db fw6 f4 mb1"
  }, [_vm._v("DISCLAIMER:")]), _vm._v(" "), _c('p', {
    staticClass: "dark-gray i f6 inter"
  }, [_vm._v("\n        We must advise you that any person who knowingly, and with intent to commit fraud, files a statement of\n        claim containing any materially false information,\n        or conceals for the purpose of misleading information concerning any fact thereto, commits a fraudulent act,\n        which is a crime and may be prosecuted to the\n        full extent of the law. By signing, I agree that the statements above are true and correct to the best of my\n        knowledge and cannot be changed once submitted to the company.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt2"
  }, [_c('label', {
    staticClass: "dib fw5 f6 mb2 inter",
    attrs: {
      "for": "disclaimer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.disclaimer),
      expression: "disclaimer"
    }],
    staticClass: "normal",
    attrs: {
      "type": "checkbox",
      "id": "disclaimer"
    },
    domProps: {
      "checked": Array.isArray(_vm.disclaimer) ? _vm._i(_vm.disclaimer, null) > -1 : (_vm.disclaimer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.disclaimer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.disclaimer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.disclaimer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.disclaimer = $$c
        }
      }
    }
  }), _vm._v("\n          I agree and am filing this claim with full knowledge of my coverage benefits as outlined in the user\n          agreement and terms and conditions.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mv4"
  }, [_c('label', {
    staticClass: "db fw6 f3 mb2",
    attrs: {
      "for": "sig"
    }
  }, [_vm._v("Please type your full name as a digital signature")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sig),
      expression: "sig"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1 w-50-ns",
    attrs: {
      "id": "sig",
      "type": "text",
      "disabled": !_vm.disclaimer
    },
    domProps: {
      "value": (_vm.sig)
    },
    on: {
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sig = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dot-navigation"
  }, _vm._l((5), function(x, index) {
    return _c('span', {
      key: x,
      staticClass: "step",
      class: [
        _vm.currentTab === index ? 'active' : '',
        _vm.currentTab > index ? 'finish' : ''
      ]
    })
  }), 0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "claim-navigation"
  }, [(!!_vm.currentClaim.id) ? _c('div', {
    staticClass: "loading-state desk silver"
  }, [_vm._v(_vm._s(_vm.loading ? 'Loading...' : 'Draft saved'))]) : _vm._e(), _vm._v(" "), (this.currentTab > 0) ? _c('ak-button', {
    attrs: {
      "type": "button",
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextPrev(-1)
      }
    }
  }, [_vm._v("Previous")]) : _vm._e(), _vm._v(" "), (this.currentTab < 4) ? _c('ak-button', {
    attrs: {
      "type": "button",
      "primary": "",
      "block": "",
      "disabled": _vm.devices.length <= 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextPrev(1)
      }
    }
  }, [_vm._v("Continue")]) : _vm._e(), _vm._v(" "), (this.currentTab >= 4 && _vm.userHasAccess) ? _c('ak-button', {
    class: [!_vm.formComplete || _vm.loading ? 'submit-disabled' : 'submit-active'],
    attrs: {
      "type": "button",
      "primary": "",
      "block": "",
      "disabled": !_vm.formComplete || _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextPrev(1)
      }
    }
  }, [_vm._v("Submit\n      ")]) : _vm._e()], 1), _vm._v(" "), (!!_vm.currentClaim.id) ? _c('div', {
    staticClass: "loading-state mob silver"
  }, [_vm._v(_vm._s(_vm.loading ? 'Loading...' : 'Draft saved'))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db f4 fw8 mb3"
  }, [_vm._v("Select your items that were damaged or stolen:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw8 f3 mb3",
    attrs: {
      "for": "loss_type"
    }
  }, [_vm._v("Type of loss"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Accidental Damage"
    }
  }, [_c('option', {
    attrs: {
      "value": "Cracked Screen"
    }
  }, [_vm._v("Cracked Screen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cracked Back"
    }
  }, [_vm._v("Cracked Back")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Cracked Camera"
    }
  }, [_vm._v("Cracked Camera")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Liquid Damage"
    }
  }, [_vm._v("Liquid Damage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accidental Damage - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Malfunctions"
    }
  }, [_c('option', {
    attrs: {
      "value": "Screen"
    }
  }, [_vm._v("Screen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Camera"
    }
  }, [_vm._v("Camera")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Charging Port"
    }
  }, [_vm._v("Charging Port")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Battery"
    }
  }, [_vm._v("Battery")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Malfunctions - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('optgroup', {
    attrs: {
      "label": "Theft and Vandalism"
    }
  }, [_c('option', {
    attrs: {
      "value": "Theft"
    }
  }, [_vm._v("Theft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Theft from Unattended Vehicle"
    }
  }, [_vm._v("Theft from Unattended Vehicle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Vandalism"
    }
  }, [_vm._v("Vandalism")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Theft and Vandalism - Other"
    }
  }, [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw8 f3 mb2",
    attrs: {
      "for": "loss_date"
    }
  }, [_vm._v("Date of loss"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "db fw8 f3 mb2",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description of Incident:"), _c('span', {
    staticClass: "color-theme f5"
  }, [_vm._v(" *")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-639aab40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddClaim2.vue
// module id = 1379
// module chunks = 0